import React from "react";
import PageTemplate from "../components/template/PageTemplate"

const Resume = () => {
  return (
    <PageTemplate>
    <section className="page-content">
      <h1 className="page-heading">Resume</h1>
      <p>Download my resume and explore my professional experience.</p>
    </section>
    </PageTemplate>
  );
};

export default Resume;
